
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype3Off as ObiMosfetPtype3OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-3-off.js';
 
 
 

 
 export const ObiMosfetPtype3Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-3-off',
   elementClass: ObiMosfetPtype3OffElement,
   events: {
     
   }
  });
 
 